/**
 * Add to cart from URL: ?items=SKU1,SKU2&seller=123
 * Storefront API only (search by SKU), no Liquid template.
 * Requires themeVariables.shopifyStorefrontAccessToken and themeVariables.shopDomain (js-variables.liquid).
 */
(async function addItemsFromUrl() {
  const PREFIX = "[cart-from-url]";
  const log = (...args) => console.log(PREFIX, ...args);
  const warn = (...args) => console.warn(PREFIX, ...args);
  const err = (...args) => console.error(PREFIX, ...args);
  const delay = (ms) => new Promise((r) => setTimeout(r, ms));

  const url = new URL(window.location.href);
  const itemsParam = url.searchParams.get("items");
  const seller = url.searchParams.get("seller");

  if (!itemsParam || !seller) return;

  const fingerprint = `addbyurl:${itemsParam}|seller:${seller}`;
  if (sessionStorage.getItem(fingerprint) === "1") return;

  const skus = itemsParam
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (!skus.length) return;

  const qtyBySku = skus.reduce((acc, sku) => {
    acc[sku] = (acc[sku] || 0) + 1;
    return acc;
  }, {});

  const token = window.themeVariables?.shopifyStorefrontAccessToken;
  const shop = window.themeVariables?.shopDomain;
  if (!token || !shop) {
    err(
      "Storefront API unavailable: missing themeVariables.shopifyStorefrontAccessToken or shopDomain",
    );
    return;
  }

  const STOREFRONT_API = "https://" + shop + "/api/2024-01/graphql.json";
  const SEARCH_BY_SKU = `
    query SearchBySku($query: String!) {
      search(first: 5, query: $query, types: PRODUCT) {
        nodes {
          ... on Product {
            variants(first: 20) {
              nodes { id sku }
            }
          }
        }
      }
    }
  `;

  async function getVariantIdBySku(sku) {
    const res = await fetch(STOREFRONT_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token,
      },
      body: JSON.stringify({
        query: SEARCH_BY_SKU,
        variables: { query: sku },
      }),
    });
    const data = await res.json();
    const nodes = data?.data?.search?.nodes || [];
    for (const product of nodes) {
      for (const v of product?.variants?.nodes || []) {
        if (v.sku === sku && v.id) {
          const numId = parseInt(v.id.split("/").pop(), 10);
          if (!isNaN(numId)) return numId;
        }
      }
    }
    return null;
  }

  const itemsForCart = [];
  for (const [sku, quantity] of Object.entries(qtyBySku)) {
    const variantId = await getVariantIdBySku(sku);
    if (variantId) itemsForCart.push({ id: variantId, quantity });
    else warn("SKU not found:", sku);
    await delay(150);
  }

  if (!itemsForCart.length) {
    warn("No variants found for any SKU");
    return;
  }

  let added = [];
  const addOne = async (item) => {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: [item] }),
    });
    const text = await res.text();
    if (res.ok) return true;
    try {
      const j = JSON.parse(text);
      warn("Not added:", item, (j.description || j.message || "").slice(0, 80));
    } catch (_) {}
    return false;
  };

  const addAllRes = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ items: itemsForCart }),
  });
  if (addAllRes.ok) {
    added = itemsForCart;
  } else {
    for (let i = 0; i < itemsForCart.length; i++) {
      if (i > 0) await delay(250);
      if (await addOne(itemsForCart[i])) added.push(itemsForCart[i]);
    }
  }

  if (added.length === 0) {
    err("No items were added to cart");
    return;
  }

  await delay(400);
  let updRes = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({
      attributes: {
        seller: String(seller),
        source_url: url.toString(),
      },
    }),
  });
  if (updRes.status === 429) {
    await delay(1000);
    updRes = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        attributes: {
          seller: String(seller),
          source_url: url.toString(),
        },
      }),
    });
  }
  if (!updRes.ok)
    err("cart/update error:", (await updRes.text()).slice(0, 200));

  sessionStorage.setItem(fingerprint, "1");

  function triggerCartRefresh() {
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  }
  triggerCartRefresh();
  setTimeout(triggerCartRefresh, 150);
  setTimeout(triggerCartRefresh, 400);
})();
